module.exports = __webpack_public_path__ + "img/MBBank.01b475e9.png";